module.exports = __webpack_public_path__ + "static/menu-dessert-59eb06eb5596befd6a2460a692373dce.png";